import React, { useEffect, useState } from 'react';
import { useFeatureQuery } from '../gql/hooks/queries/useFeatureQuery.js';
import { defaultValues } from './flags';


const FeatureFlagsContext = React.createContext( null );

export function FeatureProvider( { children } ) {

    const { data, loading } = useFeatureQuery( {
        fetchPolicy: 'network-only',
    } );

    const [ flags, setFlags ] = useState( [] );

    useEffect( () => {
        setFlags( data?.company?.variableList ?? [] );
    }, [ data, loading ] );

    return <FeatureFlagsContext.Provider value={ flags }>{ children }</FeatureFlagsContext.Provider>;
}

export function useFeatureFlag( { name } ) {
    const features = React.useContext( FeatureFlagsContext );

    // check db for rules on this company
    let feat = features?.find( feat => feat.name === name );
    if ( feat !== undefined ) {
        return feat.value === 'true';
    } 
    
    // check default behavior
    feat = defaultValues[ name ];

    return feat;
}

export function FeatureFlag( { name, children, fallback = null } ) {
    const isAllowed = useFeatureFlag( { name } );

    return isAllowed ? children : fallback;
}